import { render, staticRenderFns } from "./EnterCtaBtnCenter.vue?vue&type=template&id=706a560c&scoped=true&"
import script from "./EnterCtaBtnCenter.vue?vue&type=script&lang=js&"
export * from "./EnterCtaBtnCenter.vue?vue&type=script&lang=js&"
import style0 from "./EnterCtaBtnCenter.vue?vue&type=style&index=0&id=706a560c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706a560c",
  null
  
)

export default component.exports